/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MigrationStatus } from './migrationStatus';


export interface MigrationResponse { 
    /**
     * Error message if any.
     */
    error_message?: string;
    migration_status?: MigrationStatus;
    /**
     * Resource identifier.
     */
    resource_id?: string;
    /**
     * Resource type.
     */
    resource_type?: string;
}
export namespace MigrationResponse {
}


